<template>
  <div class="w-fit-content">
		<ts-button
			color="info"
			outline
			 @click="visible = true"
		>
			<i class="fa fa-filter"></i>
		</ts-button>
    <a-drawer
      :title="$t('filterOption')"
      placement="right"
      :closable="false"
      :visible="visible"
			width="300px"
      :zIndex="1020"
      @close="onClose"
    >
      <slot></slot>
    </a-drawer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
    }
  },
  methods: {
    onClose() {
      this.visible = false
			this.$emit('close')
    },
  },
}
</script>

<style scoped>
.w-fit-content {
  width: fit-content;
}
</style>